import { ContactInformation } from "../Components/App/appReducer"

export const DEFAULT_FORM_HEADER_1 = "Welcome!";
export const DEFAULT_FORM_HEADER_2 = "Enter your information to get started.";

export type EdullaConfig = {
    LogoUrl: string
    SquareLogoUrl: string
    TenantName?: string | null
    TypeOfBot: string
    BotName?: string
    WelcomeMessage: string
    SmallHeaderLogoUrl: string
    HeaderBackgroundImageHome: string
    PrimaryColor: string
    SecondaryColor: string
    TertiaryColor: string
    TextInputBackground: string
    BoxShadow: string
    BorderRadiusNumber: number
    Gap: string
    PaddingNumber: number
    Border: string
    FontFamily: string
    TransparentBackground: string
    ButtonBackground: string
    MuiFilledInputBackground: string
    FormHeader1?: string
    FormHeader2?: string
    FormDisclosure?: string
    HomeHeadline1: string
    HomeHeadline2: string
    HomeHeadline3: string
    HomeAskAQuestionHeadline1: string
    HomeAskAQuestionHeadline2: string
    IndexName: string
    HomeSearchHeadline1: string
    HomeSearchHeadline2: string
    RequireForm: boolean
    CustomForm?: boolean
    CustomPrompt?: boolean
    EntranceForm?: any
    ContactInformation?: ContactInformation[]
    OpenByDefault?: boolean
    PromptBubbleMessage?: string
    PromptBubbleShowOnDesktop?: boolean
    PromptBubbleShowOnMobile?: boolean
}

export const configInitial: EdullaConfig = {
    LogoUrl: "",
    SquareLogoUrl: "",
    TenantName: null,
    BotName: "bot",
    WelcomeMessage: "Hello, how can I help you today?",
    TypeOfBot: "chat",
    SmallHeaderLogoUrl: "",
    HeaderBackgroundImageHome: "",
    PrimaryColor: "",
    SecondaryColor: "",
    TertiaryColor: "",
    TextInputBackground: "",
    BoxShadow: "",
    BorderRadiusNumber: 0,
    Gap: "",
    PaddingNumber: 0,
    Border: "",
    FontFamily: "",
    TransparentBackground: "",
    ButtonBackground: "",
    MuiFilledInputBackground: "",
    FormHeader1: DEFAULT_FORM_HEADER_1,
    FormHeader2: DEFAULT_FORM_HEADER_2,
    HomeHeadline1: "",
    HomeHeadline2: "",
    HomeHeadline3: "",
    IndexName: "",
    HomeAskAQuestionHeadline1: "",
    HomeAskAQuestionHeadline2: "",
    HomeSearchHeadline1: "",
    HomeSearchHeadline2: "",
    RequireForm: true,
    CustomForm: false,
    CustomPrompt: false,
    EntranceForm: {},
    OpenByDefault: false,
    PromptBubbleMessage: "Hello! Is there anything I can help you with today?",
    PromptBubbleShowOnDesktop: true,
    PromptBubbleShowOnMobile: true
}
